import React from 'react';

interface TabIconProps {
  active: boolean;
}

const MethodologyIcon: React.FC<TabIconProps> = ({ active }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.53328 1.66797C6.69233 1.66797 5.19995 3.16035 5.19995 5.0013V7.5013H2.69995V9.16797H5.19995V15.0013C5.19995 15.9218 4.45376 16.668 3.53328 16.668H2.69995V18.3346H3.53328C5.37423 18.3346 6.86662 16.8422 6.86662 15.0013V9.16797H9.36662V7.5013H6.86662V5.0013C6.86662 4.08083 7.61281 3.33464 8.53328 3.33464H9.36662V1.66797H8.53328ZM12.8685 14.1656L10.1089 17.5013H12.272L13.95 15.4729L15.628 17.5013H17.791L15.0315 14.1656L17.7871 10.8346H15.624L13.95 12.8582L12.276 10.8346H10.1129L12.8685 14.1656Z"
      fill={active ? '#4E3178' : '#738290'}
    />
  </svg>
);

export default MethodologyIcon;
